'use strict';

var util = require('../util/property-util');
var arrayUtil = require('../util/array-util');
var nocUtil = require('../util/noc-util');
var moment = require('moment-timezone');

module.exports = /*@ngInject*/ ["$cookies", "$rootScope", "LocaleFactory", "ConfigService", function ($cookies, $rootScope, LocaleFactory, ConfigService) {
    var factory = {
        timezones: [
            "America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
            "America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
            "America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
            "Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
            "Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
            "Etc/UTC|UTC|0|0|",
            "Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
            "Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
            "Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5"
        ],
        timeZoneNames: [],
        defaultTimeZone: "Etc/UTC"
    };


    moment.tz.add(
        factory.timezones
    );

    factory.timezones.forEach(function (zone) {
        var zoneParts = zone.split('|');
        var name = zoneParts[0];
        var value = name.split("/")[1].replace("_", " ");
        var abbreviatedName = moment.tz(name)._z.abbr(new Date());
        var abbreviations = arrayUtil.isEmpty(zoneParts[1].split(" ")) ? zoneParts[1].split("/") : zoneParts[1].split(" ");
        factory.timeZoneNames.push({
            name: name,
            value: value,
            abbreviations: abbreviations,
            abbreviatedName: util.isDefined(abbreviatedName) ? abbreviatedName : value
        });
    });

    factory.lookUpTimeZone = function (timezone) {
        var result = undefined;
        var byName = arrayUtil.getFirstInList(factory.timeZoneNames, "name", timezone);
        if (util.isDefined(byName)) {
            result = angular.copy(byName);
        } else {
            factory.timeZoneNames.some(function (zone) {
                if (arrayUtil.contains(zone.abbreviations, timezone)) {
                    result = angular.copy(zone);
                    return true;
                }
            });
        }

        if (!util.isDefined(result)) {
            result = factory.lookUpTimeZone(factory.defaultTimeZone);
        }

        return result;
    };

    $rootScope.$on("timeZoneChanged", function () {
        factory.preferredTimeZone = factory.getTzFromCookie();
    });

    $rootScope.$on("localeChanged", function () {
        moment.locale(LocaleFactory.getLocale(true), {
            week: {
                dow: 1 // Monday is the first day of the week
            }
        });
    });


    factory.toUTC = function (millis, formatString) {
        return moment.tz(millis, "Etc/UTC").format(formatString);
    };

    factory.toUTCUrlFormat = function (millis) {
        return factory.toUTC(millis, 'YYYY-MM-DD-HH:mm');
    };

    factory.toTz = function (date) {
        return moment.tz(date, factory.preferredTimeZone);
    };

    /**
     * Format a date in the preferred time zone
     *
     * @param date          millis or Date object
     * @param dateFormat    moment.js notation, e.g. 'YYYY-MM-DD-HH:mm'
     */
    factory.format = function (date, dateFormat) {
        return moment(nocUtil.toDate(date)).tz(factory.getTzFromCookie()).format(dateFormat);
    };

    factory.formatUtcToTz = function (time, dateFormat) {
        if (util.isDefined(dateFormat)) {
            return moment.tz(time, factory.preferredTimeZone).format(dateFormat);
        } else {
            return moment.tz(time, factory.preferredTimeZone).format();
        }
    };

    factory.formatWithTimeZone = function (date, dateFormat) {
        return factory.dateInCurrentTimeZone(date).format(dateFormat);
    };

    factory.dateInCurrentTimeZone = function (date) {
        var converted = nocUtil.toDate(date);
        var yyyyMMDDHHMM = moment(converted).format('YYYY-MM-DD HH:mm');
        return moment.tz(yyyyMMDDHHMM, factory.preferredTimeZone);
    };

    factory.currentDateToTimeZone = function (date, dateFormat) {
        var x = moment(date).tz(factory.preferredTimeZone);
        if (util.isDefined(dateFormat)) {
            return x.format(dateFormat);
        } else {
            return x.format();
        }
    };

    factory.toTzDate = function (date) {
        return moment(nocUtil.toDate(date)).toDate();
    };


    factory.getTimeZone = function () {
        return factory.preferredTimeZone;
    };

    factory.getTimeZones = function () {
        return factory.timeZoneNames;
    };

    factory.getOffset = function () {
        var current = moment(new Date()).format("Z").split(':')[0] * 60;
        var wanted = moment.tz(factory.preferredTimeZone).format("Z").split(':')[0] * 60;
        if( current === wanted){
            return 0;
        }else {
            return (current - wanted) * 60 * 1000;
        }
    };

    factory.getXOffset = function () {
        var now = new Date();
        var currentOffset = now.getTimezoneOffset(); //eg. -120 == GMT +02:00
        var wantedOffset = factory.format(new Date(), "Z").split(':')[0] * 60;

        //identical timezone?
        if (moment.tz(factory.preferredTimeZone).format("Z") === moment.tz(moment.tz.guess()).format("Z")) {
            wantedOffset = 0;
            currentOffset = 0;
        }
        return (currentOffset + wantedOffset) * 60 * 1000;
    };

    factory.decreaseWithOffSet = function (milliseconds) {
        var offset = getXOffset();

        if (0 < offset) {
            return milliseconds - offset;
        } else {
            return milliseconds + offset;
        }

    };

    factory.formatPeriodInCurrentTimezone = function (from, to) {
        return {
            start: factory.dateInCurrentTimeZone(from).format(),
            end: factory.dateInCurrentTimeZone(to).format()
        }
    };

    /**
     * Requires 2 valid date objects OR time representation in millis.
     * Incoming time is considered as UTC time.
     * @param from
     * @param to
     * @param format wanted output format, default YYYY-MM-DDTHH:mm:ssZ
     *
     * example:
     *  var initialFromUTC = Date.UTC(2015, 6, 15, 13, 18, 0);
     *  var initialToUTC = Date.UTC(2015, 6, 15, 13, 20, 0);
     *  var periodTextUTC = TimeZoneFactory.formatUtcToBackendPeriod(initialFromUTC, initialToUTC);
     *
     *  -> periodText.start = "2015-07-15T13:18:00+00:00"
     *  -> periodText.end = "2015-07-15T13:20:00+00:00"
     *
     * returns object with start and end date value + timezone info.
     */
    factory.formatUtcToBackendPeriod = function (from, to, completeDayPeriod, param1Name, param2Name, format) {
        var start, end;
        var form = util.isDefined(format) ? format : "YYYY-MM-DDTHH:mm:ssZ";

        if (from && from.getTime) {
            start = from.getTime();
        } else {
            start = from;
        }

        if (to && to.getTime) {
            end = to.getTime();
        } else {
            end = to;
        }

        var timezone = util.isDefined(factory.preferredTimeZone) ? factory.preferredTimeZone : factory.defaultTimeZone;
        param1Name = (param1Name? param1Name : "start");
        param2Name = (param2Name? param2Name : "end");
        if (completeDayPeriod) {
            return {
                [param1Name] : moment(start).startOf("day").tz(timezone).format(form),
                [param2Name] : moment(end).endOf("day").tz(timezone).format(form)
            };
        } else {
            return {
                [param1Name] : moment(start).tz(timezone).format(form),
                [param2Name] : moment(end).tz(timezone).format(form)
            };
        }
    };

    /**
     * Expects a time period object (start && end hh:mm notation.).
     * Strips hh:mm out of scheduleDayTimestamp date and creates a new period object with start and end time copied from initial time period
     * @param scheduleDayTimestamp Regular Date object.
     * @param timePeriod  {{ start: '10:00', end: '12:00' }}
     * @returns {{start: Date, end: Date}}
     */
    factory.composeCustomPeriod = function (scheduleDayTimestamp, timePeriod) {
        var startDate = new Date(scheduleDayTimestamp);
        var endDate = new Date(scheduleDayTimestamp);

        var startTimeHour = Number(timePeriod.start.split(":")[0].replace("\'", ""));
        var endTimeHour = Number(timePeriod.end.split(":")[0].replace("\'", ""));

        if (startTimeHour > endTimeHour) {
            //jump to next day.
            endTimeHour += 24;
        }

        var startTimeMinutes = Number(timePeriod.start.split(":")[1].replace("\'", ""));
        var endTimeMinutes = Number(timePeriod.end.split(":")[1].replace("\'", ""));

        startDate.setHours(startTimeHour);
        startDate.setMinutes(startTimeMinutes);
        startDate.setSeconds(0);

        endDate.setHours(endTimeHour);
        endDate.setMinutes(endTimeMinutes);
        endDate.setSeconds(0);

        return {
            start: startDate,
            end: endDate
        };
    };

    factory.isSelected = function (timezone) {
        var zone = factory.lookUpTimeZone(timezone);
        return zone.name === factory.preferredTimeZone;
    };

    factory.getTzFromCookie = function () {
        var timeZone = undefined;
        try {
            timeZone = $cookies.get('nomad.noc.ng.timezone');
        } catch (error) {
            console.warn("Unable to parse timezone from cookie. Falling back to guess/default");
        }
        if (!util.isDefined(timeZone)) {
            var tzGuess = moment.tz.guess();
            var defaultTz = "UTC";
            if (util.isDefined(tzGuess)) {
                var continent = util.isDefined(tzGuess.split) && tzGuess.split("/").length > 1 ? tzGuess.split("/")[0] : "unknown";
                switch (continent) {
                    case "Europe":
                        defaultTz = "CET";
                        break;
                    case "America":
                        defaultTz = "EDT";
                        break;
                    case "Indian":
                    case "Asia":
                        defaultTz = "IST";
                        break;

                }
            }
            timeZone = defaultTz;
        }
        var final = factory.lookUpTimeZone(timeZone).name;
        $cookies.put('nomad.noc.ng.timezone', final, { secure: ConfigService.get('secureCookies')});
        return final;
    };

    factory.addTimeZoneToTimestamp = function (dataArray) {
        var offset = factory.getOffset();
        dataArray.forEach(function (value) {
            value.timestamp = value.timestamp - offset;
        });
        return dataArray;
    };

    factory.getPreferedTimeZoneName = function () {
        return factory.lookUpTimeZone(factory.preferredTimeZone);
    };

    factory.getTzFromCookie();

    return factory;

}];